import { MESSAGES_COPY } from '../messages/COPY';

export const FILE_NAME = {
	MAX: 64,
	MESSAGE: MESSAGES_COPY.INVALID_FILE_NAME
};
